import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Users } from 'lucide-react';
import { axios, auth, API, mbUrl, muted, primary, card, runCall } from './mbApi';

const ROLES = [
  { key: 'strategist_id', label: 'Strategist / Brief (Kaer)' },
  { key: 'creative_id', label: 'Creative & Review (Firzan)' },
  { key: 'media_buyer_id', label: 'Media Buyer (Azrai)' },
];

export const OwnersCard = ({ ibId, owners, canManage, onSaved }) => {
  const [members, setMembers] = useState([]);
  const [form, setForm] = useState(owners || {});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/team-members`, auth()).then((r) => setMembers(r.data.members || [])).catch(() => {});
  }, []);
  useEffect(() => { setForm(owners || {}); }, [owners]);

  const nameOf = (id) => members.find((m) => m.id === id)?.name || '—';
  const save = () => runCall(setBusy, async () => {
    await axios.put(mbUrl(ibId, '/settings'), { owners: form }, auth());
    onSaved();
  }, 'Owners saved');

  return (
    <div className={card} data-testid="mb-owners-card">
      <p className={`text-sm font-semibold ${primary} flex items-center gap-2 mb-1`}><Users size={15} /> Owners kerja</p>
      <p className={`text-[11px] ${muted} mb-3`}>Owners = siapa PIC setiap tahap (hak ubah tahap tu). Owners TIDAK beri akses channel — setiap orang juga mesti ada channel ni dalam Channel Access (Admin → User Management).</p>
      <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_1fr_auto] gap-2 items-end">
        {ROLES.map((r) => (
          <div key={r.key}>
            <label className={`text-[11px] ${muted}`}>{r.label}</label>
            {canManage ? (
              <Select value={form[r.key] || 'none'} onValueChange={(v) => setForm({ ...form, [r.key]: v === 'none' ? '' : v })}>
                <SelectTrigger className="mt-1" data-testid={`mb-owner-${r.key}`}><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="none">— Belum pilih —</SelectItem>
                  {members.map((m) => <SelectItem key={m.id} value={m.id}>{m.name} · {m.email}</SelectItem>)}
                </SelectContent>
              </Select>
            ) : (
              <p className={`text-sm ${primary} mt-1`} data-testid={`mb-owner-${r.key}`}>{nameOf(form[r.key])}</p>
            )}
          </div>
        ))}
        {canManage && <Button size="sm" variant="outline" onClick={save} disabled={busy} data-testid="mb-owners-save">Save</Button>}
      </div>
    </div>
  );
};
